import React, { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import NotesSidebar from './NotesSidebar';
import { Bars3Icon } from '@heroicons/react/24/outline';
import useBreakpoint from '../../hooks/useBreakpoint';
import { NotesActionsProvider } from './NotesActionsContext';

const NotesLayout = () => {
    const { isMobile } = useBreakpoint();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleCloseSidebar = useCallback(() => {
        setIsSidebarOpen(false);
    }, []);

    useEffect(() => {
        setIsSidebarOpen(!isMobile);
    }, [isMobile]);

    useEffect(() => {
        if (isMobile && isSidebarOpen) {
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = '';
            };
        }

        document.body.style.overflow = '';
        return () => {
            document.body.style.overflow = '';
        };
    }, [isSidebarOpen]);

    return (
        <NotesActionsProvider>
            <div className="flex h-screen bg-white dark:bg-gray-900 overflow-hidden">
            {/* Mobile Sidebar Overlay */}
            {isMobile && !isSidebarOpen && (
                <button
                    onClick={() => setIsSidebarOpen(true)}
                    className="fixed top-4 left-4 z-40 md:hidden inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-white/95 dark:bg-gray-800/95 backdrop-blur border border-gray-200/80 dark:border-gray-700/80 text-gray-700 dark:text-gray-200 shadow-[0_8px_24px_rgba(15,23,42,0.16)] hover:shadow-[0_10px_28px_rgba(15,23,42,0.2)] hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] transition-all duration-200"
                    aria-label="Menüyü aç"
                >
                    <Bars3Icon className="w-5 h-5" />
                </button>
            )}

            {/* Sidebar */}
            <div
                className={`fixed inset-y-0 left-0 z-50 w-64 bg-gray-50 dark:bg-gray-850 border-r border-gray-200 dark:border-gray-800 transform transition-transform duration-300 ease-in-out md:relative md:translate-x-0 ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}
            >
                <NotesSidebar onClose={handleCloseSidebar} />
            </div>

            {isMobile && isSidebarOpen && (
                <button
                    type="button"
                    aria-label="Sidebar kapat"
                    onClick={handleCloseSidebar}
                    className="fixed inset-0 z-40 bg-black/30 md:hidden"
                />
            )}

            {/* Main Content */}
            <div className={`flex-1 flex flex-col min-w-0 overflow-hidden bg-white dark:bg-gray-900 ${isMobile && !isSidebarOpen ? 'pt-16' : ''}`}>
                <main className="flex-1 overflow-y-auto focus:outline-none">
                    <Outlet />
                </main>
            </div>
            </div>
        </NotesActionsProvider>
    );
};

export default NotesLayout;
